export enum InterviewDetailTab {
  Highlights = 'Highlights',
  Summary = 'Summary',
  Analytics = 'Analytics',
  Clips = 'Clips',
  Assistant = 'Assistant',
}
